import React, { Component } from 'react';
import { PreviousButton } from '../components/PreviousButton';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    nextStep(s: string): void;
    prevStep(): void;
    updateLead(props: any): void;
}

export class IsFirstMortgage extends Component<IProps, any> {
    constructor (props: IProps) {
        super(props);
        this.nextStep = this.nextStep.bind(this);
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep(response: string) {
        this.props.updateLead({isFirstMortgage: response === 'yes'});
        this.props.nextStep(response);
    }

    render() {

        return (
            <header className="App-header">
                <h1>Is this your first mortgage?</h1>
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 flex-end'>
                            <div className='boxty small' onClick={() => this.nextStep('yes')}>
                                <div><h2 className='btn'>Yes</h2></div>
                            </div>
                        </div>
                        <div className='column2 flex-start'>
                            <div className='boxty small' onClick={() => this.nextStep('no')}>
                                <div><h2 className='btn'>No</h2></div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}
